module.exports = __webpack_public_path__ + "02_long_black.1d000a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_long_black.png
// module id = Wgl+
// module chunks = 0